import { render, staticRenderFns } from "./PeriodDiffNoChangeIcon.vue?vue&type=template&id=280cc2d8&scoped=true"
import script from "./PeriodDiffNoChangeIcon.vue?vue&type=script&lang=js"
export * from "./PeriodDiffNoChangeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cc2d8",
  null
  
)

export default component.exports